"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Asterisk = exports.Label = exports.LabelText = exports.Container = exports.Input = exports.IconWrapper = exports.RichTextLabel = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _link = require("@berlitz/link");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var RichTextLabel = _styledComponents.default.span.withConfig({
  displayName: "Checkboxstyle__RichTextLabel",
  componentId: "sc-1ob6epv-0"
})(["p{display:inline;}a:not([data-key='max-button']){font-size:inherit;", "}"], function (_ref) {
  var inverse = _ref.inverse;
  return inverse ? (0, _styledComponents.css)(["", ""], _link.linkStyleInverse) : (0, _styledComponents.css)(["", ""], _link.linkStyle);
});
exports.RichTextLabel = RichTextLabel;
var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Checkboxstyle__IconWrapper",
  componentId: "sc-1ob6epv-1"
})(["opacity:0;transform:scale(0);transition:all ", ";", ";"], function (_ref2) {
  var checkbox = _ref2.theme.checkbox;
  return checkbox.transition;
}, function (_ref3) {
  var checked = _ref3.checked;
  return checked && (0, _styledComponents.css)(["opacity:1;transform:scale(1);"]);
});
exports.IconWrapper = IconWrapper;
var Input = _styledComponents.default.input.withConfig({
  displayName: "Checkboxstyle__Input",
  componentId: "sc-1ob6epv-2"
})(["position:absolute;top:0;left:0;width:", ";height:", ";opacity:0;cursor:inherit;margin:0;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme.checkbox.size;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.checkbox.size;
}, function (_ref6) {
  var native = _ref6.native;
  return native && (0, _styledComponents.css)(["opacity:1;z-index:2;width:20px;height:100%;filter:brightness(1.2);"]);
});
exports.Input = Input;
var Container = _styledComponents.default.span.withConfig({
  displayName: "Checkboxstyle__Container",
  componentId: "sc-1ob6epv-3"
})(["align-items:center;display:flex;height:", ";width:", ";justify-content:center;flex-shrink:0;margin-top:", ";", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.checkbox.size;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.checkbox.size;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.xxs;
}, function (_ref10) {
  var checkbox = _ref10.theme.checkbox,
    checked = _ref10.checked;
  return (0, _styledComponents.css)(["border:", ";border-radius:", ";transition:all ", ";background-color:", "};"], checkbox.border, checkbox.borderRadius, checkbox.transition, checked ? checkbox.colorChecked : checkbox.color);
});
exports.Container = Container;
var LabelText = _styledComponents.default.span.withConfig({
  displayName: "Checkboxstyle__LabelText",
  componentId: "sc-1ob6epv-4"
})(["", " margin-top:3px;", ""], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: ", ";\n    margin-right: 0;\n  "])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.checkbox.labelMargin;
}), function (_ref12) {
  var light = _ref12.light;
  return light && (0, _styledComponents.css)(["color:", ";"], function (_ref13) {
    var theme = _ref13.theme;
    return theme.formField.labelColorLight;
  });
});
exports.LabelText = LabelText;
var Label = _styledComponents.default.label.withConfig({
  displayName: "Checkboxstyle__Label",
  componentId: "sc-1ob6epv-5"
})(["align-items:flex-start;cursor:pointer;display:flex;position:relative;justify-content:flex-start;outline:none;> input:focus + ", "{outline-color:-webkit-focus-ring-color;outline-style:auto;}"], Container);
exports.Label = Label;
var Asterisk = _styledComponents.default.span.withConfig({
  displayName: "Checkboxstyle__Asterisk",
  componentId: "sc-1ob6epv-6"
})(["speak:none;color:", ";", " ", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colorSupport01;
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.xxs;
}), function (_ref16) {
  var light = _ref16.light,
    theme = _ref16.theme;
  return (0, _styledComponents.css)(["color:", ";"], light ? theme.formField.requiredAsteriskColorLight : theme.formField.requiredAsteriskColor);
});
exports.Asterisk = Asterisk;